import '../scss/style.scss';

import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

import { Main } from './Main';

export function init() {
  new Main();

  const firebaseConfig = {
    apiKey: process.env.API_KEY,
    authDomain: process.env.AUTH_DOMAIN,
    projectId: process.env.PROJECT_ID,
    storageBucket: process.env.STORAGE_BUCKET,
    messagingSenderId: process.env.MESSAGING_SENDER_ID,
    appId: process.env.APP_ID,
  };

  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
}

document.addEventListener('DOMContentLoaded', init);
